import ViberLink from './ViberLink';

export default ViberLink;
